import React from "react";
import { Routes, Route } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

// Pages
import HomePage from "./pages/HomePage";
import RSVPPage from "./pages/RSVPPage";
import PhotoGalleryPage from "./pages/PhotoGalleryPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminEventsPage from "./pages/admin/AdminEventsPage";
import AdminPhotosPage from "./pages/admin/AdminPhotosPage";
import RSVPDetailPage from "./pages/admin/RSVPDetailPage";
import AdminNotificationPreferencesPage from "./pages/admin/AdminNotificationPreferencesPage";
import AdminEntrancePage from "./pages/admin/AdminEntrancePage";

// Components
import ProtectedRoute from "./components/ProtectedRoute";
import LoadingSpinner from "./components/LoadingSpinner";
import { useAuth } from "./context/AuthContext";

const App: React.FC = () => {
  const { isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <AnimatePresence mode="wait">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/rsvp" element={<RSVPPage />} />
          <Route path="/gallery" element={<PhotoGalleryPage />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/events"
            element={
              <ProtectedRoute>
                <AdminEventsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/photos"
            element={
              <ProtectedRoute>
                <AdminPhotosPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/rsvp/:rsvpId"
            element={
              <ProtectedRoute>
                <RSVPDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/notifications"
            element={
              <ProtectedRoute>
                <AdminNotificationPreferencesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/entrance"
            element={
              <ProtectedRoute>
                <AdminEntrancePage />
              </ProtectedRoute>
            }
          />

          {/* 404 Route */}
          <Route
            path="*"
            element={
              <motion.div
                className="min-h-screen flex items-center justify-center"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <div className="text-center">
                  <h1 className="text-4xl font-bold text-primary-900 mb-4">
                    404
                  </h1>
                  <p className="text-gray-600 mb-8">Page not found</p>
                  <a href="/" className="btn-primary">
                    Go Home
                  </a>
                </div>
              </motion.div>
            }
          />
        </Routes>
      </AnimatePresence>
    </div>
  );
};

export default App;
